'use client';

export type CollabConnectionStatus = 'connected' | 'connecting' | 'disconnected';

export type CollabPresenceUser = {
  clientId: number;
  id: string | null;
  email?: string | null;
  avatar?: string | null;
  name: string;
  color: string;
  isSelf: boolean;
};

export type CollabPresencePayload = {
  room: string | null;
  status: CollabConnectionStatus;
  users: CollabPresenceUser[];
};

export const COLLAB_PRESENCE_EVENT = 'vault:collab-presence';
